import { Button, Dialog, Alert, Typography, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function GuideReassignDialog(props: any) {
  const { setLoading, openDialog, setOpenDialog, loadList, guideCode, currentVehicleId, currentVehicleName, currentLicensePlate } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [vehicleId, setVehicleId] = useState<number | string>('');
  const [vehiclesList, setVehiclesList] = useState<any[]>([]);

  useEffect(() => {
    if (openDialog) {
      loadVehicles();
      if (currentVehicleId) {
        setVehicleId(currentVehicleId);
      }
    } else {
      setVehicleId('');
    }
  }, [openDialog, currentVehicleId]);

  const loadVehicles = async () => {
    await ApiRequest({
      url: "/vehicles/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        full_list: true,
      },
      setResponse: (response: any) => {
        if (response.list) {
          setVehiclesList(response.list);
        }
      },
    });
  };

  const handleSubmit = async () => {
    if (!guideCode || !vehicleId) {
      enqueueSnackbar("Por favor seleccione un vehículo", { variant: "error" });
      return;
    }

    setLoading(true);

    await ApiRequest({
      url: "/guides/reassignGuide",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        guide_code: guideCode,
        vehicle_id: vehicleId,
      }),
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Guía reasignada con éxito", { variant: "success" });
          setOpenDialog(false);
          setVehicleId('');
          loadList();
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  const handleClose = () => {
    setOpenDialog(false);
    setVehicleId('');
  };

  return (
    <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={{ p: 3 }}>
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Reasignar guía</h2>
            <span className="h2_subtitle">Cambiar vehículo asignado</span>
          </div>
        </div>

        <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold">
            Guía: {guideCode}
          </Typography>
          <Typography variant="body2">
            Vehículo actual: {currentLicensePlate ? `${currentLicensePlate} - ${currentVehicleName}` : 'Sin asignar'}
          </Typography>
        </Alert>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="vehicle-select-label">Vehículo asignado</InputLabel>
          <Select
            labelId="vehicle-select-label"
            id="vehicle-select"
            value={vehicleId}
            label="Vehículo asignado"
            onChange={(e) => setVehicleId(e.target.value)}
          >
            {vehiclesList.map((vehicle: any) => (
              <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                {vehicle.license_plate} - {vehicle.vehicle_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Reasignar
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
